import { InvoicesGetListParamsT } from '@/core/types/invoices.types'
import { reactive } from 'vue'

const filters_state = reactive({
    search: null as string | null,
    dopInvoiceNumber: null as string | null,
    takeDateFrom: null as string | null,
    takeDateTo: null as string | null,
    orderNumber: null as string | null,
    startTime: null as string | null,
    endTime: null as string | null,
    companyId: null as number | null,
    senderCity: null as number | null,
    receiverCity: null as number | null,
    senderAddress: null as string | null,
    receiverAddress: null as string | null,
    deliveryDateFrom: null as string | null,
    deliveryDateTo: null as string | null,
    paymentType: null as number | null,
    shipmentType: null as number | null,
    statusIds: [] as number[],
    billingEnabled: null as number | null,
    calculationStatus: [] as number[],
    isCancelled: null as number | null,
    paymentMethods: [] as number[],
    hasAdditionalService: null as number | null,
    hideDopInvoices: null as number | null,
    isSelfDelivery: null as string | null,
    isPickup: null as string | null,
    archive: null as number | null,
    export: null as number | null,
    import: null as number | null,
    receiverComment: null as string | null,
    managerId: null as number | null,
})

export default function () {
    const setFilters = (params: InvoicesGetListParamsT) => {
        filters_state.search = params.search
        filters_state.dopInvoiceNumber = params.dopInvoiceNumber
        filters_state.takeDateFrom = params.takeDateFrom
        filters_state.takeDateTo = params.takeDateTo
        filters_state.orderNumber = params.orderNumber
        filters_state.startTime = params.startTime === '' ? null : params.startTime
        filters_state.endTime = params.endTime === '' ? null : params.endTime
        filters_state.companyId = params.companyId
        filters_state.senderCity = params.senderCity
        filters_state.receiverCity = params.receiverCity
        filters_state.senderAddress = params.senderAddress
        filters_state.receiverAddress = params.receiverAddress
        filters_state.deliveryDateFrom = params.deliveryDateFrom
        filters_state.deliveryDateTo = params.deliveryDateTo
        filters_state.paymentType = params.paymentType
        filters_state.shipmentType = params.shipmentType
        filters_state.statusIds = params.statusIds
        filters_state.billingEnabled = params.billingEnabled
        filters_state.calculationStatus = params.calculationStatus
        filters_state.isCancelled = params.isCancelled
        filters_state.paymentMethods = params.paymentMethods
        filters_state.hasAdditionalService = params.hasAdditionalService
        filters_state.hideDopInvoices = params.hideDopInvoices
        filters_state.isSelfDelivery = params.isSelfDelivery
            ? params.isSelfDelivery.toString()
            : null
        filters_state.isPickup = params.isPickup ? params.isPickup.toString() : null
        filters_state.archive = params.archive
        filters_state.export = params.export
        filters_state.import = params.import
        filters_state.receiverComment = params.receiverComment
        filters_state.managerId = params.managerId
    }

    const unsetFilters = () => {
        filters_state.search = null
        filters_state.dopInvoiceNumber = null
        filters_state.takeDateFrom = null
        filters_state.takeDateTo = null
        filters_state.orderNumber = null
        filters_state.startTime = null
        filters_state.endTime = null
        filters_state.companyId = null
        filters_state.senderCity = null
        filters_state.receiverCity = null
        filters_state.senderAddress = null
        filters_state.receiverAddress = null
        filters_state.deliveryDateFrom = null
        filters_state.deliveryDateTo = null
        filters_state.paymentType = null
        filters_state.shipmentType = null
        filters_state.statusIds = []
        filters_state.billingEnabled = null
        filters_state.calculationStatus = []
        filters_state.isCancelled = null
        filters_state.paymentMethods = []
        filters_state.hasAdditionalService = null
        filters_state.hideDopInvoices = null
        filters_state.isSelfDelivery = null
        filters_state.isPickup = null
        filters_state.archive = null
        filters_state.export = null
        filters_state.import = null
        filters_state.receiverComment = null
        filters_state.managerId = null
    }

    return { filters_state, setFilters, unsetFilters }
}
